import { alert } from "./alert";
import { getErrorMessage, getErrorMessageHeader } from "./errorHandling";
import { getErrorCode } from "./getErrorCode";

export function errorAlert(args) {
    var responseErrorCode = getErrorCode(args.response),
        responseMessage = getErrorMessage({ errorCode: responseErrorCode }),
        header = getErrorMessageHeader({ errorCode: responseErrorCode });

    alert({
        header: header,
        message: responseMessage,
        type: "danger"
    });
}
